import React, { Component } from 'react';
import styles from './LoginPage.module.scss';
import logoLarge from '../../resources/images/logo-large.png';
import amazonLogoLarge from '../../resources/images/amazon-logo-large.png';
import Icon from '@ant-design/icons';
import { ReactComponent as Login1 } from '../../resources/images/login-1.svg';
import { ReactComponent as Login2 } from '../../resources/images/login-2.svg';
import { ReactComponent as Login3 } from '../../resources/images/login-3.svg';
import { Button, Carousel, Col, Layout, Modal, Result, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import CustomContext from '../../context/CustomContext';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent';
import { Header } from 'antd/lib/layout/layout';
import { adminApiBaseURL } from '../../api/CustomAxios';

class LoginPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            if (this.props.location.search.includes('error')) {
                Modal.error({
                    title: this.props.intl.formatMessage({ id: 'login.error' }),
                    content: this.props.intl.formatMessage({ id: 'login.error.description' }),
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <Layout className={styles.layout}>
                <Header>
                    <HeaderComponent />
                </Header>
                <Row className={styles.content} justify="center">
                    <Col span={12} className={styles.info}>
                        {this.renderInfo()}
                    </Col>
                    <Col span={12} className={styles.login}>
                        {this.renderForm()}
                    </Col>
                </Row>
            </Layout>
        );
    };

    renderInfo = (): React.ReactElement | undefined => {
        const title = (
            <>
                <span className={styles.bold}>PreCon</span>nector
            </>
        );
        return (
            <>
                <Carousel autoplay speed={2000}>
                    <Result
                        title={
                            <h3>
                                {title} <FormattedMessage id="login.info.1" />
                            </h3>
                        }
                        subTitle={
                            <h4>
                                <FormattedMessage id="login.info.1.desc" />
                            </h4>
                        }
                        icon={<Icon component={Login1} className={styles.image} />}
                    />
                    <Result
                        title={
                            <h3>
                                {title} <FormattedMessage id="login.info.2" />
                            </h3>
                        }
                        subTitle={
                            <h4>
                                <FormattedMessage id="login.info.2.desc" />
                            </h4>
                        }
                        icon={<Icon component={Login2} className={styles.image} />}
                    />
                    <Result
                        title={
                            <h3>
                                {title} <FormattedMessage id="login.info.3" />
                            </h3>
                        }
                        subTitle={
                            <h4>
                                <FormattedMessage id="login.info.3.desc" />
                            </h4>
                        }
                        icon={<Icon component={Login3} className={styles.image} />}
                    />
                </Carousel>
                <img src={amazonLogoLarge} alt="Logo" className={styles.amazon} />
            </>
        );
    };

    renderForm = (): React.ReactElement | undefined => {
        return (
            <>
                <Row justify="center">
                    <Col span="16" className={styles.title}>
                        <p>
                            <FormattedMessage id="login.login.title" />
                        </p>
                        <p>
                            <FormattedMessage id="login.login.description" />
                        </p>
                    </Col>
                </Row>
                <Row justify="center" className={styles.buttons}>
                    <Col span="16">
                        {false && (
                            <a href={`${adminApiBaseURL}/oauth2/authorization/amazon`}>
                                <Button type="primary" size="large" block className={styles.amazon}>
                                    <FormattedMessage id="login.login.amazon" />
                                </Button>
                            </a>
                        )}
                        <a href={`${adminApiBaseURL}/oauth2/authorization/autodesk`}>
                            <Button type="primary" size="large" block className={styles.autodesk}>
                                <FormattedMessage id="login.login.autodesk" />
                            </Button>
                        </a>
                    </Col>
                </Row>
                <Row justify="center" className={styles.hint}>
                    <Col span="16">
                        <FormattedMessage id="login.login.hint" />{' '}
                        <a href="mailto:preconnector@modelical.com" className={styles.link}>
                            <FormattedMessage id="login.login.contactUs" />
                        </a>
                        .
                    </Col>
                </Row>
                <Row justify="center" className={styles.hint}>
                    <Col span="16">
                        <a
                            href="https://forms.gle/dmYZnnszp43ip3yo6"
                            className={styles.link}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FormattedMessage id="login.login.requestAccess" />
                        </a>
                    </Col>
                </Row>
                <Row justify="center" className={styles.logo}>
                    <Col span="16">
                        <img src={logoLarge} alt="Logo" />
                    </Col>
                </Row>
            </>
        );
    };

    render() {
        const { auth } = this.context;

        if (!auth) {
            return <>{this.renderContent()}</>;
        } else {
            return <Redirect to="/" />;
        }
    }
}
export default injectIntl(LoginPage);

interface Props extends WrappedComponentProps, RouteComponentProps {}

interface State {
    loading?: boolean;
}
